import React from 'react'
import PropTypes from 'prop-types'
import { v4 as uuidv4 } from 'uuid'

const FileUploader = ({
  UploadButton = null,
  label = 'Add file',
  disabled,
  onLoadListUpdate,
  onTaskUpdate,
  uploadFunction,
  buttonId = 'uploader-button-default',
  mimeTypes = 'image/png,image/jpeg,image/jpg,image/gif,application/pdf,application/x-pdf,application/zip,application/x-7z-compressed,application/msword,application/vnd.ms-office,application/x-rar-compressed,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet application/vnd.openxmlformats-officedocument.presentationml.presentation',
}) => {
  const handleChange = (e) => {
    const newTasks = Array.from(e.currentTarget.files).map((val) => ({
      name: val.name,
      progress: 0,
      uuid: uuidv4(),
    }))

    onLoadListUpdate(newTasks)

    Promise.all(
      newTasks.map(async function (task, index) {
        const file = e.currentTarget.files[index]
        let formData = new FormData()
        formData.append('file', file)

        const { response, error } = await uploadFunction({
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: function (progressEvent) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            )

            onTaskUpdate(task.uuid, {
              progress: percentCompleted,
              total: progressEvent.total,
            })
          },
        })

        if (error) {
          onTaskUpdate(task.uuid, {
            error: error?.errors?.[0]
              ? `${error?.errors?.[0]}`
              : 'upload_error_default',
          })
          formData.delete('file')
        } else {
          onTaskUpdate(task.uuid, {
            ...response.data,
            complete: true,
          })
        }
      }),
    )

    e.target.type = 'text'
    e.target.value = ''
    e.target.type = 'file'
  }

  return (
    <div style={{ visibility: 'hidden', height: '0', position: 'absolute' }}>
      {UploadButton && (
        <UploadButton name={buttonId} label={label} disabled={disabled} />
      )}

      <input
        disabled={disabled}
        type="file"
        name="file-uploader"
        id={buttonId}
        onChange={handleChange}
        multiple
        accept={mimeTypes}
      />
    </div>
  )
}

FileUploader.propTypes = {
  buttonId: PropTypes.string,
  disabled: PropTypes.bool,
  onTaskUpdate: PropTypes.func,
  onLoadListUpdate: PropTypes.func,
  uploadFunction: PropTypes.func,
  name: PropTypes.string,
  mimeTypes: PropTypes.string,
  label: PropTypes.string,
  UploadButton: PropTypes.elementType,
}

FileUploader.defaultProps = {
  onLoadUpdate: () => {},
  uploadFunction: () =>
    new Promise((resolve) => setTimeout(() => resolve(), 1000)),
}

export default FileUploader
